<script setup lang="ts">
import { Locale } from '~/i18n/i18nConfig';

// COMPOSABLES
const { locale } = useTypedI18n();

// DATA
const phoneLabel = computed(() => {
    switch (locale.value) {
        case Locale.PL:
            return '+48 22 397 06 04';

        default:
            return '+39 0287176063';
    }
});
const phoneNumber = computed(() => phoneLabel.value.replace(/ /g, ''));
</script>
<template>
    <BasePhoneLink :phone="phoneNumber">
        <slot>{{ phoneLabel }}</slot>
    </BasePhoneLink>
</template>
